<template>
	<el-dialog
		:visible.sync="visible"
		:show-close="false"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		class="role-dialog"
		width="550px">
		<span slot="title" class="dialog-title">
			<span>{{title}}</span>
			<img src="@/assets/images/close.png" alt="" @click="visible = false">
		</span>
		<el-form :model="dataForm" :rules="dataRule" label-position="top" ref="dataForm">
			<el-form-item label="零件名称(中文)" prop="pcilNumberNameCn">
				<el-input v-model="dataForm.pcilNumberNameCn" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
			</el-form-item>
			<el-form-item label="零件名称(英文)" prop="pcilNumberNameEn">
				<el-input v-model="dataForm.pcilNumberNameEn" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
			</el-form-item>
			<el-form-item label="零件编号" prop="partNumber">
				<el-input v-model="dataForm.partNumber" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
			</el-form-item>
			<el-form-item label="适配机型" prop="deviceAdapt">
				<el-input v-model="dataForm.deviceAdapt" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
			</el-form-item>
			<el-form-item label="PM更换周期" prop="replaceCycle">
				<el-input v-model="dataForm.replaceCycle" placeholder="请输入" maxlength="32" :disabled="readonly"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button v-if="!readonly" :loading="submitLoading" class="submit-btn" @click="submit">确定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { debounce } from '@/utils/debounce'

export default {
	data() {
		return {
			title: '新增送货地址',
			visible: false,
			readonly: false,
			editType: 'add',
			submitLoading: false,
			dataForm: {
				id: '',
				pcilNumberNameCn: '', //零件名称(中文)
				pcilNumberNameEn: '', // 零件名称(英文)
				partNumber: '', // 零件编号
				deviceAdapt: '', // 适配机型
				replaceCycle: '', // PM更换周期
			},
			submitUrl: 'repairModelAdd',
			dataRule: {
				pcilNumberNameCn: [
					{ required: true, message: '零件名称(中文)不能为空', trigger: "blur" }
				],
				pcilNumberNameEn: [
					{ required: true, message: '零件名称(英文)不能为空', trigger: "blur" }
				],
				partNumber: [
					{ required: true, message: '零件编号不能为空', trigger: "blur" }
				],
				deviceAdapt: [
					{ required: true, message: '适配机型不能为空', trigger: "blur" }
				],
				replaceCycle: [
					{ required: false, message: 'PM更换周期不能为空', trigger: "blur" }
				]
			},
		}
	},
	created() {
	},
	methods: {
		init(type, data) {
			this.visible = true;
			this.$nextTick(() => {
				this.$refs.dataForm.resetFields();
				this.editType = type;
				this.dataForm ={
					...data
				}
				if (type === 'add') {
					this.title = '新增常用零件';
					this.submitUrl = 'dataPartNumberCommonAdd';
					this.readonly = false;

					delete this.dataForm.id;
				} else if (type === 'edit') {
					this.title = '修改常用零件';
					this.submitUrl = 'dataPartNumberCommonUpdate';
					this.readonly = false;
				} else {
					this.title = '查看常用零件';
					this.submitUrl = '';
					this.readonly = true;
				}
			})
		},
		submit: debounce(function () {
			if (this.visible == false) {
				return
			}
			this.$refs['dataForm'].validate(valid => {
				if (valid) {
					let that = this;
					that.submitLoading = true
					that.$request.post(
						that.submitUrl,
						false,
						that.dataForm,
						function (r) {
							if (r.code == "0") {
								that.visible = false;
								that.$emit('refresh');
								that.$message.success('保存成功');
							} else {
								that.$message.error(r.msg);
							}
							that.submitLoading = false
						}
					);
				} else {
					return false;
				}
			});
		}, 1000),
	}
}
</script>
<style lang="scss" scoped>
.dialog-title {
	display: block;
	text-align: center;

	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}

	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}

.el-form-item {
	margin-bottom: 10px;

	.el-select {
		width: 100%;
	}
}

.submit-btn {
	width: 100%;
	background-color: #117FFC;
	color: #fff;
}

.role-dialog /deep/ .el-dialog {
	border-radius: 10px !important;
}

.role-dialog /deep/ .el-dialog__body {
	padding: 0 20px !important;
}

.role-dialog /deep/ .el-form-item__label {
	padding: 0 !important;
}

.role-dialog /deep/ .el-dialog__footer {
	padding: 20px 20px 30px !important;
}
</style>
